"use client";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { DEFAULT_TIME_ZONE_PREFERENCE, getBrowserTimeZone, serializeTimeZonePreference, TIMEZONE_COOKIE_MAX_AGE_DAYS, TIMEZONE_COOKIE_NAME, UTC_TIME_ZONE } from "../lib/timezone.js";
var TimeZoneContext = createContext(null);
function writeCookie(preference) {
  if (typeof document === "undefined") {
    return;
  }
  var maxAge = TIMEZONE_COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = "".concat(TIMEZONE_COOKIE_NAME, "=").concat(encodeURIComponent(serializeTimeZonePreference(preference)), "; path=/; max-age=").concat(maxAge, "; samesite=lax");
}
export function TimeZoneProvider(_a) {
  var initial = _a.initial,
    children = _a.children;
  var _b = useState(initial),
    preference = _b[0],
    setPreference = _b[1];
  var _c = useState(initial.timeZone),
    browserTimeZone = _c[0],
    setBrowserTimeZone = _c[1];
  useEffect(function () {
    var sync = function () {
      var detected = getBrowserTimeZone();
      setBrowserTimeZone(detected);
      setPreference(function (current) {
        if (current.mode !== "local" || current.timeZone === detected) {
          return current;
        }
        var next = {
          mode: "local",
          timeZone: detected
        };
        writeCookie(next);
        return next;
      });
    };
    sync();
    window.addEventListener("focus", sync);
    document.addEventListener("visibilitychange", sync);
    return function () {
      window.removeEventListener("focus", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, []);
  var setMode = useCallback(function (mode) {
    var next = {
      mode: mode,
      timeZone: mode === "utc" ? UTC_TIME_ZONE : getBrowserTimeZone()
    };
    writeCookie(next);
    setPreference(next);
  }, []);
  var value = useMemo(function () {
    return __assign(__assign({}, preference), {
      browserTimeZone: browserTimeZone,
      setMode: setMode
    });
  }, [preference, browserTimeZone, setMode]);
  return _jsx(TimeZoneContext.Provider, {
    value: value,
    children: children
  });
}
export function useDisplayTimeZone() {
  var _a;
  return (_a = useContext(TimeZoneContext)) !== null && _a !== void 0 ? _a : FALLBACK;
}
var FALLBACK = __assign(__assign({}, DEFAULT_TIME_ZONE_PREFERENCE), {
  browserTimeZone: UTC_TIME_ZONE,
  setMode: function () {}
});